define( [
	"./arr"
], function( arr ) {
	"use strict";

	return arr.slice;
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/slice.js
 ** module id = 132
 ** module chunks = 0
 **/